import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { TCreateTemplateFromCampaignPayload } from '~/features/admin/models'
import { TCampaignTemplate } from '~/features/campaigns/models'
import { EHttpService, EServerPath, TErrorResponse } from '~/models/api'
import HttpService from '~/services/http'

const createTemplateFromCampaign = async ({
  payload,
}: {
  payload: TCreateTemplateFromCampaignPayload
}) =>
  HttpService.post<TCampaignTemplate>(
    {
      path: EServerPath.campaignCreateTemplateFromCampaign,
      payload,
    },
    EHttpService.internal,
  ).then((res) => res.data)

const useCreateTemplateFromCampaign = () => {
  return useMutation({
    mutationFn: createTemplateFromCampaign,
    onSuccess: () => {
      toast.success('Template created successfully')
    },
    onError: (error: TErrorResponse) => {
      const errorMessage =
        error.response?.data?.message ||
        'Failed to create template from campaign'
      toast.error(errorMessage)
    },
  })
}

export default useCreateTemplateFromCampaign
